import { UNDEFINED_LABEL } from "@/constants";
export function strPadLeft(string, pad, length) {
  return (new Array(length + 1).join(pad) + string).slice(-length);
}

export function getMinuteFromSecond(seconds) {
  return Math.floor(seconds / 60);
}

export function getSecondFromSecond(seconds) {
  return seconds - getMinuteFromSecond(seconds) * 60;
}

/**
 *
 * @param {*} value
 * @returns {Boolean}
 */
export function isString(value) {
  return typeof value === "string" || value instanceof String;
}

export function postDataToNativeApp(functionName, data) {
  const jsonstr = JSON.stringify(data);
  const ua = window.navigator.userAgent.toLowerCase();
  const isIOS =
    ua.includes("iphone") || ua.includes("ipod") || ua.includes("ipad");
  if (isIOS) {
    if (jsonstr) {
      window.webkit.messageHandlers[functionName].postMessage(jsonstr);
    } else {
      window.webkit.messageHandlers[functionName].postMessage("{}");
    }
  } else {
    if (jsonstr) {
      window.android_app[functionName](jsonstr);
    } else {
      window.android_app[functionName]();
    }
  }
}

export function filterDuplicateLabels(labels = []) {
  if (labels?.length > 0) {
    let result = [];
    labels.forEach((item) => {
      if (!result.some((_item) => _item === item)) {
        result.push(item);
      } else {
        result.push("");
      }
    });
    return result;
  }
  return [];
}

export function changeDuplicateLabels(labels = []) {
  if (labels?.length > 0) {
    let result = [];
    labels.forEach((item, index) => {
      if (!result.some((_item) => _item === item)) {
        result.push(item);
      } else {
        result.push(UNDEFINED_LABEL + item);
      }
    });
    return result;
  }
  return [];
}

export function initLineChartData() {
  const startHour = 0;
  const endHour = 23;
  const startMinute = 0;
  const endMinute = 59;
  const unit = 3; // X軸の時間は３時間毎のメモリにする。
  let result = {};
  for (let i = startHour; i <= endHour; i++) {
    let iu = Math.floor(i / unit) * unit;
    for (let j = startMinute; j <= endMinute; j++) {
      result[`${i}:${j}`] = {
        label: j === startMinute && i === iu ? `${iu}` : UNDEFINED_LABEL + iu,
        value: undefined,
      };
    }
  }
  return result;
}

export function initLineChartDataOnlyHour() {
  const startHour = 0;
  const endHour = 23;
  const unit = 3; // X軸の時間は３時間毎のメモリにする。
  let result = {};
  for (let i = startHour; i <= endHour; i++) {
    let iu = Math.floor(i / unit) * unit;
    result[`${i}`] = {
      label: i === iu ? `${iu}` : UNDEFINED_LABEL + iu,
      value: undefined,
    };
  }
  return result;
}

/**
 * @param {Number} value
 * @returns {String}
 */
export function formatMinute2HourJP(value) {
  const hours = Math.floor(value / 60);
  const minutes = Math.round(value % 60);
  return `${hours}時間${minutes}分`;
}

/**
 * @param {Number} value
 * @returns {String}
 */
export function formatHourJP(value) {
  if (!value) {
    return "0時間0分";
  }
  const hour = 60;
  const minutes = Math.round(value * hour) % hour;
  return `${Math.floor(value)}時間${minutes}分`;
}

/**
 * @param {Number} value
 * @returns {String}
 */
export function getImgWeather(code) {
  let srcImg = require("@/assets/icons/weather/100.svg");
  switch (code) {
    case 0:
      srcImg = require("@/assets/icons/weather/100.svg");
      break;
    case (1, 2, 3):
      srcImg = require("@/assets/icons/weather/101.svg");
      break;
    case (45, 48):
      srcImg = require("@/assets/icons/weather/200.svg");
      break;
    case (51, 53, 55):
      srcImg = require("@/assets/icons/weather/300.svg");
      break;
    case (56, 57):
      srcImg = require("@/assets/icons/weather/850.svg");
      break;
    case (61, 63, 65):
      srcImg = require("@/assets/icons/weather/300.svg");
      break;
    case (66, 67):
      srcImg = require("@/assets/icons/weather/430.svg");
      break;
    case (71, 73, 75):
      srcImg = require("@/assets/icons/weather/950.svg");
      break;
    case 77:
      srcImg = require("@/assets/icons/weather/400.svg");
      break;
    case (80, 81, 82):
      srcImg = require("@/assets/icons/weather/850.svg");
      break;
    case (85, 86):
      srcImg = require("@/assets/icons/weather/430.svg");
      break;
    case 95:
      srcImg = require("@/assets/icons/weather/200.svg");
      break;
    case (96, 99):
      srcImg = require("@/assets/icons/weather/650.svg");
      break;
  }
  return srcImg;
}

/**
 * @param {Number} value
 * @returns {String}
 */
export function formatWalks(value = `76.2 (03/10)`) {
  return value;
}

/**
 * Recursively merges properties of multiple source objects into a target object.
 * Note: This function modifies the target object.
 *
 * @param {Object} target - The target object to merge into.
 * @param {...Object} sources - The source objects whose properties will be merged into the target.
 * @returns {Object} - The target object with merged properties.
 */
export function mergeDeepObjects(target, ...sources) {
  if (!sources.length) return target;

  const source = sources.shift();

  if (source) {
    for (const key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        if (
          typeof source[key] === "object" &&
          typeof target[key] === "object"
        ) {
          target[key] = mergeDeepObjects(target[key] || {}, source[key]);
        } else {
          target[key] = source[key];
        }
      }
    }
  }

  return mergeDeepObjects(target, ...sources);
}

/**
 * Safely merges properties of multiple source objects into a target object.
 * This function does not modify the original objects.
 *
 * @param {Object} target - The target object to merge into.
 * @param {...Object} sources - The source objects whose properties will be merged into the target.
 * @returns {Object} - A new object with merged properties.
 * @example
 * const merged = mergeDeepObjectsSafe({ a: 1 }, { b: { c: { d: { e: 12345 } } } });
 * console.dir(merged); // { a: 1, b: { c: { d: { e: 12345 } } } }
 */
export function mergeDeepObjectsSafe(target, ...sources) {
  return mergeDeepObjects({}, target, ...sources);
}

/**
 * @param {Number} value
 * @returns {String}
 */
export function formatHourAndMinuteJP(value) {
  if (!value) {
    return "0分";
  }
  const TOTAL_MINUTE_IN_A_HOUR = 60;
  if (value <= TOTAL_MINUTE_IN_A_HOUR) {
    return `${value}分`;
  }
  const hour = Math.floor(value / TOTAL_MINUTE_IN_A_HOUR);
  const remainingMinutes = value % TOTAL_MINUTE_IN_A_HOUR;
  return `${hour}時間${remainingMinutes}分`;
}

function isNumber(value) {
  return typeof value === "number";
}

export function roundNumberToFixed(number, roundDigit) {
  if (!isNumber(number) || isNaN(number)) return number;
  if (Number.isInteger(roundDigit) && roundDigit >= 0) {
    return Number(number.toFixed(roundDigit));
  }
  return number;
}

/**
 *
 * @param {Object} obj
 * @param {String} key
 * key contain dot like "address.country.city.ward" => obj.address.country.city.ward
 * @returns {*}
 */
export function getNestedValue(obj, key) {
  try {
    const KEY_SEPARATE_CHARACTER = ".";
    if (key.includes(KEY_SEPARATE_CHARACTER)) {
      return key.split(KEY_SEPARATE_CHARACTER).reduce((acc, cur) => {
        return acc ? acc[cur] : "";
      }, obj);
    } else {
      return obj[key];
    }
  } catch (error) {
    console.log(error);
  }
}

export function roundUpToHundreds(number) {
  return Math.ceil(number / 100) * 100;
}
